import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsAccordionModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { TranslateModule } from '@ngx-translate/core';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsTooltipConditionalModule } from '../../detail/pillar-two/transcript-summary/tooltip-conditional.module';

import { CaEvaluationComponent } from './ca-evaluation.component';
import { ToolbarComponent } from './component/toolbar/toolbar.component';

@NgModule({
    declarations: [CaEvaluationComponent, ToolbarComponent],
    exports: [CaEvaluationComponent, ToolbarComponent],
    imports: [
        CmpsAccordionModule,
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsTooltipConditionalModule,
        CmpsTooltipModule,
        CommonModule,
        TranslateModule,
    ],
})
export class CmpsCaEvaluationModule {}
